/**
 * Why a `/ws` handshake was denied. Carried on `connect_error.data.code`.
 */
export enum WebsocketHandshakeErrorCodeEnum {
  /** Cookie missing, expired, revoked, or unreadable. A refresh may fix it. */
  SESSION_INVALID = 'session_invalid',
  /** Session is live but cannot be used on a socket. Do not refresh or retry. */
  SESSION_REJECTED = 'session_rejected',
  /** Verification could not be completed. Retry later with the same cookie. */
  VERIFY_UNAVAILABLE = 'verify_unavailable',
}
